'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactI18next = require('react-i18next');

var _formComponents = require('components/formComponents');

var _components = require('components');

var _utils = require('helpers/utils');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _keyCodes = require('helpers/key-codes');

var _keyCodes2 = _interopRequireDefault(_keyCodes);

var _AddContactModal = require('components/AddContact/AddContactModal/AddContactModal');

var _AddContactModal2 = _interopRequireDefault(_AddContactModal);

var _reduxForm = require('redux-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./AddContactSuggestForm.scss');

var AddContactSuggestForm = (_dec = (0, _reduxForm.reduxForm)({
  form: 'addContactSuggestForm',
  propNamespace: 'addContactSuggestForm',
  initialValues: { userEmail: '' }
}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AddContactSuggestForm, _Component);

  function AddContactSuggestForm() {
    var _ref;

    (0, _classCallCheck3.default)(this, AddContactSuggestForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddContactSuggestForm.__proto__ || (0, _getPrototypeOf2.default)(AddContactSuggestForm)).call.apply(_ref, [this].concat(args)));

    _this.state = { showModal: false };
    return _this;
  }

  (0, _createClass3.default)(AddContactSuggestForm, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: 'onSuggestionSelected',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e, _ref3) {
        var suggestion = _ref3.suggestion;

        var _props, onSuggestionSelected, reset;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _utils.stopEvent)(e);
                _props = this.props, onSuggestionSelected = _props.onSuggestionSelected, reset = _props.addContactSuggestForm.reset;

                reset();
                _context.next = 5;
                return onSuggestionSelected({ suggestion: suggestion });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSuggestionSelected(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return onSuggestionSelected;
    }()
  }, {
    key: 'onKeyPress',
    value: function onKeyPress(e) {
      if (e.which !== _keyCodes2.default.enter) {
        return false;
      }
      (0, _utils.stopEvent)(e);
      this.openNameModal();
    }
  }, {
    key: 'onEmailBlur',
    value: function onEmailBlur() {
      if (!this.props.onAddNewContactLoading) {
        this.openNameModal();
      }
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      this.openNameModal();
    }
  }, {
    key: 'onAddNewContact',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(formData) {
        var _props2, onAddNewContact, fieldName, reset, data;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, onAddNewContact = _props2.onAddNewContact, fieldName = _props2.fieldName, reset = _props2.addContactSuggestForm.reset;
                data = (0, _extends4.default)((0, _defineProperty3.default)({}, fieldName, this.emailField.value), formData);
                _context2.next = 4;
                return onAddNewContact(data);

              case 4:
                reset();
                this.closeNameModal();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onAddNewContact(_x3) {
        return _ref4.apply(this, arguments);
      }

      return onAddNewContact;
    }()
  }, {
    key: 'bindFieldEl',
    value: function bindFieldEl(el) {
      this.emailField = el;
    }
  }, {
    key: 'openNameModal',
    value: function openNameModal() {
      if (this.emailField.value && !this.unmounted) {
        this.setState({ showModal: true });
      }
    }
  }, {
    key: 'closeNameModal',
    value: function closeNameModal(result) {
      if (result === null) {
        this.props.addContactSuggestForm.reset();
      }
      if (!this.unmounted) {
        this.setState({ showModal: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          items = _props3.items,
          tags = _props3.tags,
          loading = _props3.loading,
          onTagDelete = _props3.onTagDelete,
          onAddNewContactLoading = _props3.onAddNewContactLoading,
          withTags = _props3.withTags,
          fieldClass = _props3.fieldClass,
          fieldName = _props3.fieldName,
          nameField = _props3.nameField,
          autoFocus = _props3.autoFocus,
          inputClass = _props3.inputClass,
          tagNameField = _props3.tagNameField,
          tagKeyField = _props3.tagKeyField,
          required = _props3.required,
          withZIndex = _props3.withZIndex,
          onGetSuggestions = _props3.onGetSuggestions,
          handleSubmit = _props3.addContactSuggestForm.handleSubmit,
          maxSuggestions = _props3.maxSuggestions;
      var showModal = this.state.showModal;

      var showLoader = loading || onAddNewContactLoading;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { onSubmit: handleSubmit(this.onSubmit), className: styles.form },
          _react2.default.createElement(_reduxForm.Field, {
            ref: this.bindFieldEl,
            type: 'email',
            name: fieldName,
            readOnly: showLoader,
            field: nameField,
            onGetSuggestions: onGetSuggestions,
            onSuggestionSelected: this.onSuggestionSelected,
            items: items,
            onKeyPress: this.onKeyPress,
            onBlur: this.onEmailBlur,
            fieldClassName: fieldClass,
            placeholder: t('Email'),
            noIndent: true,
            hideLabel: true,
            inputClassName: inputClass,
            component: withTags ? _formComponents.formTagsInput : _formComponents.formAutosuggestInput,
            onTagDelete: onTagDelete,
            tags: tags,
            tagNameField: tagNameField,
            tagKeyField: tagKeyField,
            required: required,
            withZIndex: withZIndex,
            autoFocus: autoFocus,
            maxSuggestions: maxSuggestions
          }),
          _react2.default.createElement(
            'div',
            { className: 'text-right hide-on-desktop' },
            _react2.default.createElement(
              _Button2.default,
              { className: 'btn-stroke small squared margin-left-5', onClick: this.openNameModal },
              t('Add')
            )
          ),
          _react2.default.createElement(_components.Loader, { show: showLoader, mask: true, small: true })
        ),
        _react2.default.createElement(_AddContactModal2.default, {
          loading: onAddNewContactLoading,
          show: showModal,
          onHide: this.closeNameModal,
          onSubmit: this.onAddNewContact
        })
      );
    }
  }]);
  return AddContactSuggestForm;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addContactSuggestForm: _propTypes2.default.object,
  autoFocus: _propTypes2.default.bool,
  fieldClass: _propTypes2.default.string,
  fieldName: _propTypes2.default.string,
  inputClass: _propTypes2.default.string,
  items: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  maxSuggestions: _propTypes2.default.number,
  nameField: _propTypes2.default.string,
  onAddNewContact: _propTypes2.default.func,
  onAddNewContactLoading: _propTypes2.default.bool,
  onGetSuggestions: _propTypes2.default.func,
  onSuggestionSelected: _propTypes2.default.func,
  onTagDelete: _propTypes2.default.func,
  required: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  tagKeyField: _propTypes2.default.string,
  tagNameField: _propTypes2.default.string,
  tags: _propTypes2.default.array,
  withTags: _propTypes2.default.bool,
  withZIndex: _propTypes2.default.bool
}, _class3.defaultProps = {
  autoFocus: true,
  fieldClass: 'width-perc-100',
  fieldName: 'userEmail',
  inputClass: 'material',
  items: [],
  loading: false,
  nameField: '_name',
  onAddNewContact: _noop3.default,
  onAddNewContactLoading: false,
  onSuggestionSelected: _noop3.default,
  onTagDelete: _noop3.default,
  tagKeyField: 'recipientId',
  tagNameField: 'userEmail',
  tags: [],
  withTags: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onKeyPress', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onKeyPress'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onEmailBlur', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onEmailBlur'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSubmit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onAddNewContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddNewContact'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindFieldEl', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindFieldEl'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openNameModal', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openNameModal'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeNameModal', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeNameModal'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = AddContactSuggestForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddContact/AddContactSuggestForm/AddContactSuggestForm.js
// module id = 348
// module chunks = 1